import React, { useState } from "react";
import { ChevronDown, X } from "lucide-react";
import "./menu.css";
import scrollTopPage from "../../global";
import Logo from "../images/Mihailo.svg";

const mainLinks = [
  { href: "/", label: "Početna" },
  { href: "/biografija/", label: "Biografija" },
  { href: "/transformacije/", label: "Transformacije" },
  { href: "/kontakt/", label: "Kontakt" },
];

const uslugeLinks = [
  { href: "/trening-uzivo/", label: "Uživo trening" },
  { href: "/online-trening/", label: "Online trening" },
  { href: "/plan-ishrane/", label: "Plan ishrane" },
];

// Order: Početna, Biografija, Usluge accordion, Transformacije, Kontakt
const menuItems = [
  mainLinks[0],
  mainLinks[1],
  "usluge",
  mainLinks[2],
  mainLinks[3],
];

function Menu({ menuOpen, setMenuOpen }) {
  const [uslugeOpen, setUslugeOpen] = useState(false);

  const close = () => {
    setMenuOpen(false);
    setUslugeOpen(false);
  };

  return (
    <>
      <div
        className={"menu-overlay" + (menuOpen ? " active" : "")}
        onClick={close}
      />

      <div className={"menu-panel" + (menuOpen ? " active" : "")}>
        <div className="menu-panel-header">
          <img src={Logo} alt="Mihailo Logo" className="menu-logo" />
          <button
            className="menu-close-btn"
            onClick={close}
            aria-label="Zatvori meni"
          >
            <X size={22} strokeWidth={2.2} />
          </button>
        </div>

        <nav className="menu-nav">
          {menuItems.map((item, i) => {
            const delay = `${0.08 + i * 0.07}s`;

            if (item === "usluge") {
              return (
                <div
                  className={"menu-item" + (menuOpen ? " visible" : "")}
                  key="usluge"
                  style={{ transitionDelay: delay }}
                >
                  <button
                    className={"menu-usluge-btn" + (uslugeOpen ? " open" : "")}
                    onClick={() => setUslugeOpen(!uslugeOpen)}
                  >
                    <span>Usluge</span>
                    <ChevronDown
                      className="menu-usluge-arrow"
                      size={18}
                      strokeWidth={2}
                    />
                  </button>
                  <div
                    className={"menu-usluge-sub" + (uslugeOpen ? " open" : "")}
                  >
                    {uslugeLinks.map((sl) => (
                      <a
                        key={sl.href}
                        href={sl.href}
                        onClick={() => {
                          scrollTopPage();
                          close();
                        }}
                        className="menu-sub-link"
                      >
                        <span className="menu-sub-dot" />
                        {sl.label}
                      </a>
                    ))}
                  </div>
                </div>
              );
            }

            return (
              <div
                className={"menu-item" + (menuOpen ? " visible" : "")}
                key={item.href}
                style={{ transitionDelay: delay }}
              >
                <a
                  href={item.href}
                  className="menu-main-link"
                  onClick={() => {
                    scrollTopPage();
                    close();
                  }}
                >
                  {item.label}
                </a>
              </div>
            );
          })}
        </nav>

        <div className="menu-footer">
          <a
            href="https://www.instagram.com/mihailo.trener.zivanovic/"
            target="_blank"
            rel="noreferrer"
            className="menu-footer-btn"
          >
            Instagram
          </a>
          <a
            href="tel:+381600737363"
            className="menu-footer-btn menu-footer-btn--outline"
          >
            Pozovi me
          </a>
        </div>
      </div>
    </>
  );
}

export default Menu;
